export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-xl text-white mb-3 block">酷漫屋</span>
            <p className="text-sm text-foreground-300 leading-relaxed">
              免费漫画全集在线阅读平台，日漫韩漫国漫免费看，下拉式滚动阅读，漫画免费追更。50,000+漫画资源，200+日更章节，为漫画爱好者提供最优质的免费阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#hero" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</a>
              <a href="#about" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              <a href="#ranking" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门排行</a>
              <a href="#carousel" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门专题</a>
              <a href="#updates" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">漫画分类</h4>
            <div className="space-y-2">
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">日漫专区</a>
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">韩漫精选</a>
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">国漫新番</a>
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热血冒险</a>
              <a href="#topics" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">更多题材</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="mt-4">
              <h4 className="text-sm font-medium text-white mb-3">关注我们</h4>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                  <i className="ri-wechat-line text-foreground-200 text-sm"></i>
                </span>
                <span className="w-8 h-8 rounded-lg bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                  <i className="ri-weibo-line text-foreground-200 text-sm"></i>
                </span>
                <span className="w-8 h-8 rounded-lg bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                  <i className="ri-bilibili-line text-foreground-200 text-sm"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400 whitespace-nowrap">
            &copy; 2024 酷漫屋 - 免费漫画在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}